import axios from "axios";
import { instanceV2 } from "../instanceV2";

export const AVAX_API = {
  listToken(params: any) {
    return instanceV2.get(`/api/tokens/list`, { params });
  },
  getQuote(params: any) {
    return instanceV2.get(`/api/routing/quote`, { params });
  },
  get1Inch(params: any) {
    return instanceV2.get(`/api/routing/quote-1inch`, { params });
  },
  getKyberSwap(params: any) {
    return instanceV2.get(`/api/routing/kyberswap-quote`, { params });
  },
  getOdos(params: any) {
    return instanceV2.get(`/api/routing/odos-quote`, { params });
  },
  createSwap(params: any) {
    return instanceV2.get(`/api/swap/create`, { params });
  },
  getBalanceTokens(params: any) {
    return axios.get(
      `https://aggregator.kibble.exchange/api/multichain/balance?${params}`,
      {
        headers: {
          apiKey: "a259b891-a9d9-48e6-8a62-ee1f3fba2653",
        },
      }
    );
  },

  loginBot(params: any) {
    return axios.post(
      "https://telegram-service.kibble.exchange/api/telegram/login",
      params,
      {
        headers: {
          Accept: "*",
          "Content-Type": "application/json",
        },
      }
    );
  },

  sendNotice(params: any) {
    return axios.post(
      "https://telegram-service.kibble.exchange/api/telegram/broadcast-photo",
      {
        caption: params.caption,
        fileUrl: params.fileUrl,
        markup: {
          text: params.textBtn,
          url: params.linkBtn,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      }
    );
  },
  login(params: any) {
    return instanceV2.post(`/api/auth/login`, params);
  },
  loginSol(params: any) {
    return instanceV2.post(`/api/auth/login-solana`, params);
  },
  loginTon(params: any) {
    return instanceV2.post(`/api/auth/login-ton`, params);
  },
  verifyTx(params: any) {
    return instanceV2.post(`/api/transactions/verify`, params);
  },
  getTx() {
    return instanceV2.get(`/api/transactions`);
  },
  getPools() {
    return instanceV2.get(`/api/ido/rounds`);
  },
  getDetailPool(params: any) {
    return instanceV2.get(`/api/ido/rounds/detail`, { params });
  },
  getIDOTransaction(params: any) {
    return instanceV2.get(`/api/ido/transactions?skip=${params.page}&take=100`)
  },
  createTxJoinPool(params: any) {
    return instanceV2.post(`/api/ido/transactions/create`, params);
  },
  getBalancesIDO(params: any) {
    return instanceV2.get(`/api/ido/balances`, { params });
  },

  getClaimSchedule(params: any) {
    return instanceV2.get(`/api/ido/claim/schedule`, { params });
  },
  getClaimSignature(params: any) {
    return instanceV2.get(`/api/ido/claim/signature`, { params });
  },
  getClaimAvailable() {
    return instanceV2.get(`/api/ido/claim/claim-available`);
  },
  createClaim(params: any) {
    return instanceV2.post(`/api/ido/claim`, params);
  },
  checkUserInWhiteList(params: any) {
    return instanceV2.get(`/api/ido/rounds/is-whitelist`, { params });
  },
  listChain() {
    return instanceV2.get(`/api/chains/list`);
  },
  swap1Inch(params: any) {
    return instanceV2.get(`/api/swap/1inch`, { params });
  },
  swapCreate(params: any) {
    return instanceV2.get(`/api/swap/create`, { params });
  },
  swapKyber(params: any) {
    return instanceV2.get(`/api/swap/kyber`, { params });
  },
  swapOdos(params: any) {
    return instanceV2.get(`/api/swap/odos`, { params });
  },
  swapRubic(params: any) {
    return instanceV2.get(`/api/swap/rubic`, { params });
  },
  getDataChart(params: any) {
    return instanceV2.get(
      `https://ap-dev-kibble.netlify.app/api/poolUserBalance?wallet=${params.address}&pool=${params.pool}&v=${params.ver}`
    );
  },
  getPoolDetail(params: any) {
    return instanceV2.get(
      `https://app.kibble.exchange/pools/detail/${params.id}`
    );
  },
  getProfile() {
    return instanceV2.get(`/api/users/me`);
  },
  getPoints(seasion_id: string) {
    return instanceV2.get(`/api/point-logs/${seasion_id}`);
  },
  getLeaderboard(seasion_id: string) {
    return instanceV2.get(`/api/points/leaderboard/${seasion_id}`);
  },

  handleConnectDiscord(code: string) {
    return instanceV2.get(`/api/social/discord/callback?code=${code}`);
  },
  handleCallBackTwitter(params: {
    oauth_token: string;
    oauth_verifier: string;
  }) {
    return instanceV2.post(`/api/social/twitter`, params);
  },
  handleLoginTwitter() {
    return instanceV2.get(`/api/social/twitter/init`);
  },
  getDataCheckin() {
    return instanceV2.get(`/api/user-checkins/info`);
  },
  getTaskToday() {
    return instanceV2.get(`/api/user-checkins/task-today`);
  },
  updateProfile(params: any) {
    return instanceV2.patch(`/api/users/profile`, params);
  },
  uploadImage(params: any) {
    return instanceV2.post(`/api/files/upload-image`, params);
  },
  statisticLeaderboard() {
    return instanceV2.get("/api/statistics/leaderboard")
  }
};
